import { IconButton, gitHubIcon, googleIcon } from "@motley/design"
import { SocialProvider, useSocialConnect } from "@/auth"
import { $enum } from "@/utils"

const ICONS = {
  [SocialProvider.Google]: googleIcon,
  [SocialProvider.GitHub]: gitHubIcon,
}

export default function SocialLogin() {
  const { handleConnect, isConnecting } = useSocialConnect()

  const handleConnectPress = (provider: SocialProvider) => () => {
    handleConnect(provider)
  }

  return (
    <div className="flex flex-row justify-center gap-2">
      {$enum(SocialProvider).map((provider, label) => (
        <IconButton
          key={provider}
          icon={ICONS[provider]}
          onClick={handleConnectPress(provider)}
          disabled={isConnecting}
          title={`Continue with ${label}`}
        />
      ))}
    </div>
  )
}
